/**
 * PackageOption — one package in the picker's list: colour dot + name +
 * campaign count, then its formula set · rule set line.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';
import { Package } from 'lucide-react';
import type { FlowOptimizerPackage } from '@trafficpulse/shared';

const PackageOption: FC<{ pkg: FlowOptimizerPackage }> = ({ pkg }) => (
  <span className="flex min-w-0 flex-col">
    <span className="flex items-center gap-1.5 truncate">
      {pkg.color ? (
        <span
          aria-hidden
          className="h-2 w-2 shrink-0 rounded-full"
          style={{ backgroundColor: pkg.color }}
        />
      ) : (
        <Package className="h-3 w-3 shrink-0 text-muted-foreground" aria-hidden />
      )}
      <span className="truncate font-medium">{pkg.name}</span>
      <span className="shrink-0 text-[10px] text-muted-foreground">
        {pkg.campaignCount ?? 0} campaigns
      </span>
    </span>
    <span className="truncate pl-3.5 text-[10px] text-muted-foreground">
      Σ {pkg.formulaSetName ?? '—'} · ☰ {pkg.ruleSetName ?? '—'}
    </span>
  </span>
);

export default PackageOption;
